var React = require('react');

function InterestedListing (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.66659 2.00016V0.333496H1.99992V2.00016H0.333252V3.66683H1.99992V13.6668H3.66659V3.66683H13.6666V2.00016H3.66659ZM12.8333 10.3335V4.50016H4.49992V10.3335H12.8333Z","fill":"#424242"}));
}

InterestedListing.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = InterestedListing;

InterestedListing.default = InterestedListing;
